import { getQueryParam } from '@crehana/utils';

const getUsernameParam = () => getQueryParam('username') || '';

export default getUsernameParam;
